module.exports = __webpack_public_path__ + "img/PE.28f92163.svg";